import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const customRoutes = [
  { method: "GET", path: "/by-office", handlerName: "getByOffice" },
  { method: "GET", path: "/by-payer", handlerName: "getByPayer" },
  { method: "GET", path: "/details", handlerName: "getWithDetails" },
];

const api = new CommonAPIService(router);

export const counselorsService = {
  ...createCrudService("counselors", customRoutes, router),
  listPaginated: (params) => api.getCall("/api/counselors/paginated", params),
};
